import styled from "styled-components";

export const InputComment = styled.input`
  outline: none;
`;

// export const DetailAsideContainer = styled.div`
//   padding: 20px 16px 15px;
// `;

export const DetailLine = styled.div`
  height: 1px;
  background: #f1f3f5;
`;

export const Boldline = styled(DetailLine)`
  height: 8px;
`;
